/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class CalendarServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新建生产日历
     * @param calendarDTO calendarDTO
     * @return OK
     */
    saveCalendar(calendarDTO: CalendarDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/calendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(calendarDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveCalendar(_response);
        });
    }

    protected processSaveCalendar(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 编辑生产日历日期
     * @param calendarUpdateDTO calendarUpdateDTO
     * @return OK
     */
    updateCalendar(calendarUpdateDTO: CalendarUpdateDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/calendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(calendarUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateCalendar(_response);
        });
    }

    protected processUpdateCalendar(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 生产日历列表
     * @return OK
     */
    getCalendarList(): Promise<CalendarSimpleVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/calendar/calendar-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCalendarList(_response);
        });
    }

    protected processGetCalendarList(response: AxiosResponse): Promise<CalendarSimpleVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarSimpleVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<CalendarSimpleVO[]>(<any>null);
    }

    /**
     * 复制生产日历
     * @param calendarCopyDTO calendarCopyDTO
     * @return OK
     */
    copyCalendar(calendarCopyDTO: CalendarCopyDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/calendar/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(calendarCopyDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCopyCalendar(_response);
        });
    }

    protected processCopyCalendar(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 分页查询生产日历
     * @param calendarSearchDTO calendarSearchDTO
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageCalendar(calendarSearchDTO: CalendarSearchDTO, current: number | null | undefined, size: number | null | undefined): Promise<IPageOfCalendarSimpleVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/calendar/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(calendarSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageCalendar(_response);
        });
    }

    protected processGetPageCalendar(response: AxiosResponse): Promise<IPageOfCalendarSimpleVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfCalendarSimpleVO.fromJS(resultData200) : new IPageOfCalendarSimpleVO();
            return result200;
        }
        return Promise.resolve<IPageOfCalendarSimpleVO>(<any>null);
    }

    /**
     * 新建全年的生产日历
     * @param calendarDTO calendarDTO
     * @return OK
     */
    saveYearCalendar(calendarDTO: CalendarDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/calendar/sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(calendarDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveYearCalendar(_response);
        });
    }

    protected processSaveYearCalendar(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 同步生产日历切片
     * @return OK
     */
    syncCalendar(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/calendar/sync/time";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSyncCalendar(_response);
        });
    }

    protected processSyncCalendar(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 生产日历基础信息编辑
     * @param id (optional) id
     * @param name (optional) name
     * @param status (optional) status
     * @return OK
     */
    rename(id: string | null | undefined, name: string | null | undefined, status: number | null | undefined): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/calendar/update-basic?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRename(_response);
        });
    }

    protected processRename(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 查询生产日历详情
     * @param id id
     * @return OK
     */
    getCalendarDetail(id: string): Promise<CalendarVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/calendar/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCalendarDetail(_response);
        });
    }

    protected processGetCalendarDetail(response: AxiosResponse): Promise<CalendarVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? CalendarVO.fromJS(resultData200) : new CalendarVO();
            return result200;
        }
        return Promise.resolve<CalendarVO>(<any>null);
    }
}

export class ShiftServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新建班次模型
     * @param shiftDTO shiftDTO
     * @return OK
     */
    saveShift(shiftDTO: ShiftDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/shift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shiftDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveShift(_response);
        });
    }

    protected processSaveShift(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 编辑版次模型
     * @param updateDTO updateDTO
     * @return OK
     */
    updateShift(updateDTO: ShiftUpdateDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/shift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateShift(_response);
        });
    }

    protected processUpdateShift(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询租户下所有班次模型对应名称
     * @return OK
     */
    getShiftIndexName(): Promise<ShiftIndexNameVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/shift/indexNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetShiftIndexName(_response);
        });
    }

    protected processGetShiftIndexName(response: AxiosResponse): Promise<ShiftIndexNameVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ShiftIndexNameVO.fromJS(resultData200) : new ShiftIndexNameVO();
            return result200;
        }
        return Promise.resolve<ShiftIndexNameVO>(<any>null);
    }

    /**
     * 班次模型列表
     * @param dto dto
     * @return OK
     */
    getShiftList(dto: ShiftModelSearchDTO): Promise<ShiftSimpleVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/shift/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetShiftList(_response);
        });
    }

    protected processGetShiftList(response: AxiosResponse): Promise<ShiftSimpleVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShiftSimpleVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ShiftSimpleVO[]>(<any>null);
    }

    /**
     * 分页查询班次模型
     * @param current (optional) 当前页
     * @param dto dto
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageShift(current: number | null | undefined, dto: ShiftModelSearchDTO, size: number | null | undefined): Promise<IPageOfShiftSimpleVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/shift/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageShift(_response);
        });
    }

    protected processGetPageShift(response: AxiosResponse): Promise<IPageOfShiftSimpleVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfShiftSimpleVO.fromJS(resultData200) : new IPageOfShiftSimpleVO();
            return result200;
        }
        return Promise.resolve<IPageOfShiftSimpleVO>(<any>null);
    }

    /**
     * 查询班次详情
     * @param id id
     * @return OK
     */
    getShiftIndex(id: string): Promise<number[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/shift/shiftIndex/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetShiftIndex(_response);
        });
    }

    protected processGetShiftIndex(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<number[]>(<any>null);
    }

    /**
     * 编辑版次模型基础信息
     * @param basicDTO basicDTO
     * @return OK
     */
    updateShiftBasic(basicDTO: ShiftUpdateBasicDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/shift/updateBasic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(basicDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateShiftBasic(_response);
        });
    }

    protected processUpdateShiftBasic(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询班次详情
     * @param id id
     * @return OK
     */
    getShiftDetail(id: string): Promise<ShiftVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/shift/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetShiftDetail(_response);
        });
    }

    protected processGetShiftDetail(response: AxiosResponse): Promise<ShiftVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ShiftVO.fromJS(resultData200) : new ShiftVO();
            return result200;
        }
        return Promise.resolve<ShiftVO>(<any>null);
    }

    /**
     * 删除班次模型
     * @param id id
     * @return OK
     */
    deleteShift(id: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/shift/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteShift(_response);
        });
    }

    protected processDeleteShift(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ShiftOffDayServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 班次休息日详情
     * @param id id
     * @return OK
     */
    detail(id: string): Promise<ROfShiftOffDayVo对象> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/shift-off-day/get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfShiftOffDayVo对象> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfShiftOffDayVo对象.fromJS(resultData200) : new ROfShiftOffDayVo对象();
            return result200;
        }
        return Promise.resolve<ROfShiftOffDayVo对象>(<any>null);
    }

    /**
     * 班次休息日新增
     * @param addVO addVO
     * @return OK
     */
    insert(addVO: ShiftOffDayVo对象_1): Promise<ROfShiftOffDayVo对象> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/shift-off-day/insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addVO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: AxiosResponse): Promise<ROfShiftOffDayVo对象> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfShiftOffDayVo对象.fromJS(resultData200) : new ROfShiftOffDayVo对象();
            return result200;
        }
        return Promise.resolve<ROfShiftOffDayVo对象>(<any>null);
    }

    /**
     * 班次休息日列表
     * @param vo vo
     * @return OK
     */
    list(vo: ShiftOffDaySearchVO): Promise<ROfListOfShiftOffDayVo对象> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/shift-off-day/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vo);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ROfListOfShiftOffDayVo对象> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfShiftOffDayVo对象.fromJS(resultData200) : new ROfListOfShiftOffDayVo对象();
            return result200;
        }
        return Promise.resolve<ROfListOfShiftOffDayVo对象>(<any>null);
    }

    /**
     * 班次休息日分页
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @param vo vo
     * @return OK
     */
    page(current: number | null | undefined, size: number | null | undefined, vo: ShiftOffDaySearchVO): Promise<ROfIPageOfShiftOffDayVo对象> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/shift-off-day/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vo);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<ROfIPageOfShiftOffDayVo对象> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfShiftOffDayVo对象.fromJS(resultData200) : new ROfIPageOfShiftOffDayVo对象();
            return result200;
        }
        return Promise.resolve<ROfIPageOfShiftOffDayVo对象>(<any>null);
    }

    /**
     * 班次休息日删除
     * @param ids 主键
     * @return OK
     */
    remove(ids: string[]): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/shift-off-day/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * 班次休息日修改
     * @param updateVO updateVO
     * @return OK
     */
    update(updateVO: ShiftOffDayVo对象_2): Promise<ROfShiftOffDayVo对象> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-production-time')+ "/shift-off-day/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateVO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ROfShiftOffDayVo对象> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfShiftOffDayVo对象.fromJS(resultData200) : new ROfShiftOffDayVo对象();
            return result200;
        }
        return Promise.resolve<ROfShiftOffDayVo对象>(<any>null);
    }
}

export class CalendarCopyDTO implements ICalendarCopyDTO {
    /** 生产日历编号 */
    code!: string | undefined;
    /** 原日历Id */
    id!: string | undefined;
    /** 应用年份 */
    year!: number | undefined;

    constructor(data?: ICalendarCopyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.year = data["year"];
        }
    }

    static fromJS(data: any): CalendarCopyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarCopyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["year"] = this.year;
        return data; 
    }
}

export interface ICalendarCopyDTO {
    /** 生产日历编号 */
    code: string | undefined;
    /** 原日历Id */
    id: string | undefined;
    /** 应用年份 */
    year: number | undefined;
}

export class CalendarDTO implements ICalendarDTO {
    /** 生产日历编号 */
    code!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 具体日历时间 */
    dateDTOList!: CalendarDateDTO[] | undefined;
    /** 生产日历名称 */
    name!: string | undefined;
    /** 启用禁用(0：禁用,1:启用) */
    status!: number | undefined;
    /** 应用年份 */
    year!: number | undefined;

    constructor(data?: ICalendarDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            if (data["dateDTOList"] && data["dateDTOList"].constructor === Array) {
                this.dateDTOList = [] as any;
                for (let item of data["dateDTOList"])
                    this.dateDTOList!.push(CalendarDateDTO.fromJS(item));
            }
            this.name = data["name"];
            this.status = data["status"];
            this.year = data["year"];
        }
    }

    static fromJS(data: any): CalendarDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        if (this.dateDTOList && this.dateDTOList.constructor === Array) {
            data["dateDTOList"] = [];
            for (let item of this.dateDTOList)
                data["dateDTOList"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["status"] = this.status;
        data["year"] = this.year;
        return data; 
    }
}

export interface ICalendarDTO {
    /** 生产日历编号 */
    code: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 具体日历时间 */
    dateDTOList: CalendarDateDTO[] | undefined;
    /** 生产日历名称 */
    name: string | undefined;
    /** 启用禁用(0：禁用,1:启用) */
    status: number | undefined;
    /** 应用年份 */
    year: number | undefined;
}

export class CalendarDateDTO implements ICalendarDateDTO {
    /** 生产日历日期 */
    calendarDate!: Date | undefined;
    /** 是否高优先级(0:否,1:是) */
    isHighPriority!: number | undefined;
    /** 班次模型Id */
    modelId!: string | undefined;

    constructor(data?: ICalendarDateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendarDate = data["calendarDate"] ? new Date(data["calendarDate"].toString()) : <any>undefined;
            this.isHighPriority = data["isHighPriority"];
            this.modelId = data["modelId"];
        }
    }

    static fromJS(data: any): CalendarDateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarDateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarDate"] = this.calendarDate ? formatDate(this.calendarDate) : <any>undefined;
        data["isHighPriority"] = this.isHighPriority;
        data["modelId"] = this.modelId;
        return data; 
    }
}

export interface ICalendarDateDTO {
    /** 生产日历日期 */
    calendarDate: Date | undefined;
    /** 是否高优先级(0:否,1:是) */
    isHighPriority: number | undefined;
    /** 班次模型Id */
    modelId: string | undefined;
}

export class CalendarDayVO implements ICalendarDayVO {
    /** 班次日 */
    calendarDate!: Date | undefined;
    /** 主键Id */
    id!: string | undefined;
    /** 是否高优先级(0:否,1:是) */
    isHighPriority!: number | undefined;
    /** 班次模型Id */
    modelId!: string | undefined;
    /** 班次模型名称 */
    modelName!: string | undefined;

    constructor(data?: ICalendarDayVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendarDate = data["calendarDate"] ? new Date(data["calendarDate"].toString()) : <any>undefined;
            this.id = data["id"];
            this.isHighPriority = data["isHighPriority"];
            this.modelId = data["modelId"];
            this.modelName = data["modelName"];
        }
    }

    static fromJS(data: any): CalendarDayVO {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarDayVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarDate"] = this.calendarDate ? formatDate(this.calendarDate) : <any>undefined;
        data["id"] = this.id;
        data["isHighPriority"] = this.isHighPriority;
        data["modelId"] = this.modelId;
        data["modelName"] = this.modelName;
        return data; 
    }
}

export interface ICalendarDayVO {
    /** 班次日 */
    calendarDate: Date | undefined;
    /** 主键Id */
    id: string | undefined;
    /** 是否高优先级(0:否,1:是) */
    isHighPriority: number | undefined;
    /** 班次模型Id */
    modelId: string | undefined;
    /** 班次模型名称 */
    modelName: string | undefined;
}

export class CalendarSearchDTO implements ICalendarSearchDTO {
    /** 状态集合 */
    statusList!: number[];

    constructor(data?: ICalendarSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusList = [];
        }
    }

    init(data?: any) {
        if (data) {
            if (data["statusList"] && data["statusList"].constructor === Array) {
                this.statusList = [] as any;
                for (let item of data["statusList"])
                    this.statusList!.push(item);
            }
        }
    }

    static fromJS(data: any): CalendarSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.statusList && this.statusList.constructor === Array) {
            data["statusList"] = [];
            for (let item of this.statusList)
                data["statusList"].push(item);
        }
        return data; 
    }
}

export interface ICalendarSearchDTO {
    /** 状态集合 */
    statusList: number[];
}

export class CalendarSimpleVO implements ICalendarSimpleVO {
    /** 日历编号 */
    code!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 日历名称 */
    name!: string | undefined;
    /** 启用禁用 */
    status!: number | undefined;
    /** 应用年份 */
    year!: number | undefined;

    constructor(data?: ICalendarSimpleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.status = data["status"];
            this.year = data["year"];
        }
    }

    static fromJS(data: any): CalendarSimpleVO {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarSimpleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["year"] = this.year;
        return data; 
    }
}

export interface ICalendarSimpleVO {
    /** 日历编号 */
    code: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 日历名称 */
    name: string | undefined;
    /** 启用禁用 */
    status: number | undefined;
    /** 应用年份 */
    year: number | undefined;
}

export class CalendarUpdateDTO implements ICalendarUpdateDTO {
    /** 具体日历时间 */
    dateDTOList!: CalendarDateDTO[] | undefined;
    /** 日历Id */
    id!: string | undefined;

    constructor(data?: ICalendarUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["dateDTOList"] && data["dateDTOList"].constructor === Array) {
                this.dateDTOList = [] as any;
                for (let item of data["dateDTOList"])
                    this.dateDTOList!.push(CalendarDateDTO.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CalendarUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.dateDTOList && this.dateDTOList.constructor === Array) {
            data["dateDTOList"] = [];
            for (let item of this.dateDTOList)
                data["dateDTOList"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICalendarUpdateDTO {
    /** 具体日历时间 */
    dateDTOList: CalendarDateDTO[] | undefined;
    /** 日历Id */
    id: string | undefined;
}

export class CalendarVO implements ICalendarVO {
    /** 具体日历时间 */
    calendarDayVOList!: CalendarDayVO[] | undefined;
    /** 生产日历编号 */
    code!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 生产日历名称 */
    name!: string | undefined;
    /** 前后两天数据 */
    otherCalendarDayVOList!: CalendarDayVO[] | undefined;
    /** 启用禁用 */
    status!: number | undefined;
    /** 应用年份 */
    year!: number | undefined;

    constructor(data?: ICalendarVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["calendarDayVOList"] && data["calendarDayVOList"].constructor === Array) {
                this.calendarDayVOList = [] as any;
                for (let item of data["calendarDayVOList"])
                    this.calendarDayVOList!.push(CalendarDayVO.fromJS(item));
            }
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            if (data["otherCalendarDayVOList"] && data["otherCalendarDayVOList"].constructor === Array) {
                this.otherCalendarDayVOList = [] as any;
                for (let item of data["otherCalendarDayVOList"])
                    this.otherCalendarDayVOList!.push(CalendarDayVO.fromJS(item));
            }
            this.status = data["status"];
            this.year = data["year"];
        }
    }

    static fromJS(data: any): CalendarVO {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.calendarDayVOList && this.calendarDayVOList.constructor === Array) {
            data["calendarDayVOList"] = [];
            for (let item of this.calendarDayVOList)
                data["calendarDayVOList"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        if (this.otherCalendarDayVOList && this.otherCalendarDayVOList.constructor === Array) {
            data["otherCalendarDayVOList"] = [];
            for (let item of this.otherCalendarDayVOList)
                data["otherCalendarDayVOList"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["year"] = this.year;
        return data; 
    }
}

export interface ICalendarVO {
    /** 具体日历时间 */
    calendarDayVOList: CalendarDayVO[] | undefined;
    /** 生产日历编号 */
    code: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 生产日历名称 */
    name: string | undefined;
    /** 前后两天数据 */
    otherCalendarDayVOList: CalendarDayVO[] | undefined;
    /** 启用禁用 */
    status: number | undefined;
    /** 应用年份 */
    year: number | undefined;
}

export class IPageOfCalendarSimpleVO implements IIPageOfCalendarSimpleVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: CalendarSimpleVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfCalendarSimpleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(CalendarSimpleVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfCalendarSimpleVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfCalendarSimpleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfCalendarSimpleVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: CalendarSimpleVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfShiftOffDayVo对象 implements IIPageOfShiftOffDayVo对象 {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ShiftOffDayVo对象[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfShiftOffDayVo对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ShiftOffDayVo对象.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfShiftOffDayVo对象 {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfShiftOffDayVo对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfShiftOffDayVo对象 {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ShiftOffDayVo对象[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfShiftSimpleVO implements IIPageOfShiftSimpleVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ShiftSimpleVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfShiftSimpleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ShiftSimpleVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfShiftSimpleVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfShiftSimpleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfShiftSimpleVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ShiftSimpleVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class KeyNameDTO implements IKeyNameDTO {
    /** key */
    key!: string | undefined;
    /** 名称 */
    name!: string | undefined;

    constructor(data?: IKeyNameDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): KeyNameDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KeyNameDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        return data; 
    }
}

export interface IKeyNameDTO {
    /** key */
    key: string | undefined;
    /** 名称 */
    name: string | undefined;
}

/** 返回信息 */
export class ROfIPageOfShiftOffDayVo对象 implements IROfIPageOfShiftOffDayVo对象 {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfShiftOffDayVo对象 | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfShiftOffDayVo对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfShiftOffDayVo对象.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfShiftOffDayVo对象 {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfShiftOffDayVo对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfShiftOffDayVo对象 {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfShiftOffDayVo对象 | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfShiftOffDayVo对象 implements IROfListOfShiftOffDayVo对象 {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: ShiftOffDayVo对象[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfShiftOffDayVo对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(ShiftOffDayVo对象.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfShiftOffDayVo对象 {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfShiftOffDayVo对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfShiftOffDayVo对象 {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: ShiftOffDayVo对象[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfShiftOffDayVo对象 implements IROfShiftOffDayVo对象 {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: ShiftOffDayVo对象 | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfShiftOffDayVo对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? ShiftOffDayVo对象.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfShiftOffDayVo对象 {
        data = typeof data === 'object' ? data : {};
        let result = new ROfShiftOffDayVo对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfShiftOffDayVo对象 {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: ShiftOffDayVo对象 | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfboolean implements IROfboolean {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: boolean | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfboolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfboolean {
        data = typeof data === 'object' ? data : {};
        let result = new ROfboolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfboolean {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: boolean | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

export class ShiftDTO implements IShiftDTO {
    /** 班次编号 */
    code!: string | undefined;
    /** 班次颜色 */
    colour!: string | undefined;
    /** 班次日结束时间 */
    endTime!: number | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 班次名称 */
    name!: string | undefined;
    /** 班次数量 */
    number!: number | undefined;
    /** 班次时间 */
    shiftDetailDTOList!: ShiftDetailDTO[] | undefined;
    /** 班次日开始时间 */
    startTime!: number | undefined;

    constructor(data?: IShiftDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.colour = data["colour"];
            this.endTime = data["endTime"];
            this.id = data["id"];
            this.name = data["name"];
            this.number = data["number"];
            if (data["shiftDetailDTOList"] && data["shiftDetailDTOList"].constructor === Array) {
                this.shiftDetailDTOList = [] as any;
                for (let item of data["shiftDetailDTOList"])
                    this.shiftDetailDTOList!.push(ShiftDetailDTO.fromJS(item));
            }
            this.startTime = data["startTime"];
        }
    }

    static fromJS(data: any): ShiftDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["colour"] = this.colour;
        data["endTime"] = this.endTime;
        data["id"] = this.id;
        data["name"] = this.name;
        data["number"] = this.number;
        if (this.shiftDetailDTOList && this.shiftDetailDTOList.constructor === Array) {
            data["shiftDetailDTOList"] = [];
            for (let item of this.shiftDetailDTOList)
                data["shiftDetailDTOList"].push(item.toJSON());
        }
        data["startTime"] = this.startTime;
        return data; 
    }
}

export interface IShiftDTO {
    /** 班次编号 */
    code: string | undefined;
    /** 班次颜色 */
    colour: string | undefined;
    /** 班次日结束时间 */
    endTime: number | undefined;
    /** 主键 */
    id: string | undefined;
    /** 班次名称 */
    name: string | undefined;
    /** 班次数量 */
    number: number | undefined;
    /** 班次时间 */
    shiftDetailDTOList: ShiftDetailDTO[] | undefined;
    /** 班次日开始时间 */
    startTime: number | undefined;
}

export class ShiftDetailDTO implements IShiftDetailDTO {
    /** 班次序号名称 */
    indexName!: string | undefined;
    /** 班次模型Id */
    modelId!: string | undefined;
    /** 班次休息时段数量 */
    restNumber!: number | undefined;
    /** 班次结束时间 */
    shiftEndTime!: number | undefined;
    /** 班次序号 */
    shiftIndex!: number | undefined;
    /** 休息时段 */
    shiftRestTimeDTOList!: ShiftRestTimeDTO[] | undefined;
    /** 班次开始时间 */
    shiftStartTime!: number | undefined;

    constructor(data?: IShiftDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.indexName = data["indexName"];
            this.modelId = data["modelId"];
            this.restNumber = data["restNumber"];
            this.shiftEndTime = data["shiftEndTime"];
            this.shiftIndex = data["shiftIndex"];
            if (data["shiftRestTimeDTOList"] && data["shiftRestTimeDTOList"].constructor === Array) {
                this.shiftRestTimeDTOList = [] as any;
                for (let item of data["shiftRestTimeDTOList"])
                    this.shiftRestTimeDTOList!.push(ShiftRestTimeDTO.fromJS(item));
            }
            this.shiftStartTime = data["shiftStartTime"];
        }
    }

    static fromJS(data: any): ShiftDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indexName"] = this.indexName;
        data["modelId"] = this.modelId;
        data["restNumber"] = this.restNumber;
        data["shiftEndTime"] = this.shiftEndTime;
        data["shiftIndex"] = this.shiftIndex;
        if (this.shiftRestTimeDTOList && this.shiftRestTimeDTOList.constructor === Array) {
            data["shiftRestTimeDTOList"] = [];
            for (let item of this.shiftRestTimeDTOList)
                data["shiftRestTimeDTOList"].push(item.toJSON());
        }
        data["shiftStartTime"] = this.shiftStartTime;
        return data; 
    }
}

export interface IShiftDetailDTO {
    /** 班次序号名称 */
    indexName: string | undefined;
    /** 班次模型Id */
    modelId: string | undefined;
    /** 班次休息时段数量 */
    restNumber: number | undefined;
    /** 班次结束时间 */
    shiftEndTime: number | undefined;
    /** 班次序号 */
    shiftIndex: number | undefined;
    /** 休息时段 */
    shiftRestTimeDTOList: ShiftRestTimeDTO[] | undefined;
    /** 班次开始时间 */
    shiftStartTime: number | undefined;
}

export class ShiftDetailVO implements IShiftDetailVO {
    /** 主键Id */
    id!: string | undefined;
    /** 班次序号名称 */
    indexName!: string | undefined;
    /** 班次休息时段数量 */
    restNumber!: number | undefined;
    /** 班次结束时间 */
    shiftEndTime!: number | undefined;
    /** 班次序号 */
    shiftIndex!: number | undefined;
    /** 休息时段 */
    shiftRestTimeVOList!: ShiftRestTimeVO[] | undefined;
    /** 班次开始时间 */
    shiftStartTime!: number | undefined;

    constructor(data?: IShiftDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.indexName = data["indexName"];
            this.restNumber = data["restNumber"];
            this.shiftEndTime = data["shiftEndTime"];
            this.shiftIndex = data["shiftIndex"];
            if (data["shiftRestTimeVOList"] && data["shiftRestTimeVOList"].constructor === Array) {
                this.shiftRestTimeVOList = [] as any;
                for (let item of data["shiftRestTimeVOList"])
                    this.shiftRestTimeVOList!.push(ShiftRestTimeVO.fromJS(item));
            }
            this.shiftStartTime = data["shiftStartTime"];
        }
    }

    static fromJS(data: any): ShiftDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["indexName"] = this.indexName;
        data["restNumber"] = this.restNumber;
        data["shiftEndTime"] = this.shiftEndTime;
        data["shiftIndex"] = this.shiftIndex;
        if (this.shiftRestTimeVOList && this.shiftRestTimeVOList.constructor === Array) {
            data["shiftRestTimeVOList"] = [];
            for (let item of this.shiftRestTimeVOList)
                data["shiftRestTimeVOList"].push(item.toJSON());
        }
        data["shiftStartTime"] = this.shiftStartTime;
        return data; 
    }
}

export interface IShiftDetailVO {
    /** 主键Id */
    id: string | undefined;
    /** 班次序号名称 */
    indexName: string | undefined;
    /** 班次休息时段数量 */
    restNumber: number | undefined;
    /** 班次结束时间 */
    shiftEndTime: number | undefined;
    /** 班次序号 */
    shiftIndex: number | undefined;
    /** 休息时段 */
    shiftRestTimeVOList: ShiftRestTimeVO[] | undefined;
    /** 班次开始时间 */
    shiftStartTime: number | undefined;
}

export class ShiftIndexNameVO implements IShiftIndexNameVO {
    keyNameDTOList!: KeyNameDTO[] | undefined;

    constructor(data?: IShiftIndexNameVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["keyNameDTOList"] && data["keyNameDTOList"].constructor === Array) {
                this.keyNameDTOList = [] as any;
                for (let item of data["keyNameDTOList"])
                    this.keyNameDTOList!.push(KeyNameDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShiftIndexNameVO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftIndexNameVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.keyNameDTOList && this.keyNameDTOList.constructor === Array) {
            data["keyNameDTOList"] = [];
            for (let item of this.keyNameDTOList)
                data["keyNameDTOList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IShiftIndexNameVO {
    keyNameDTOList: KeyNameDTO[] | undefined;
}

export class ShiftModelSearchDTO implements IShiftModelSearchDTO {
    /** 状态集合 */
    statusList!: number[] | undefined;

    constructor(data?: IShiftModelSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["statusList"] && data["statusList"].constructor === Array) {
                this.statusList = [] as any;
                for (let item of data["statusList"])
                    this.statusList!.push(item);
            }
        }
    }

    static fromJS(data: any): ShiftModelSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftModelSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.statusList && this.statusList.constructor === Array) {
            data["statusList"] = [];
            for (let item of this.statusList)
                data["statusList"].push(item);
        }
        return data; 
    }
}

export interface IShiftModelSearchDTO {
    /** 状态集合 */
    statusList: number[] | undefined;
}

export class ShiftOffDaySearchVO implements IShiftOffDaySearchVO {
    /** 休息日-结束 */
    endOffDay!: Date | undefined;
    /** 休息日-开始 */
    startOffDay!: Date | undefined;
    /** 年份 */
    year!: number | undefined;

    constructor(data?: IShiftOffDaySearchVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endOffDay = data["endOffDay"] ? new Date(data["endOffDay"].toString()) : <any>undefined;
            this.startOffDay = data["startOffDay"] ? new Date(data["startOffDay"].toString()) : <any>undefined;
            this.year = data["year"];
        }
    }

    static fromJS(data: any): ShiftOffDaySearchVO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftOffDaySearchVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endOffDay"] = this.endOffDay ? formatDate(this.endOffDay) : <any>undefined;
        data["startOffDay"] = this.startOffDay ? formatDate(this.startOffDay) : <any>undefined;
        data["year"] = this.year;
        return data; 
    }
}

export interface IShiftOffDaySearchVO {
    /** 休息日-结束 */
    endOffDay: Date | undefined;
    /** 休息日-开始 */
    startOffDay: Date | undefined;
    /** 年份 */
    year: number | undefined;
}

/** 班次休息日 */
export class ShiftOffDayVo对象 implements IShiftOffDayVo对象 {
    /** 休息日-结束 */
    endOffDay!: Date | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 备注/说明 */
    remark!: string | undefined;
    /** 休息日-开始 */
    startOffDay!: Date | undefined;
    /** 年份 */
    year!: number | undefined;

    constructor(data?: IShiftOffDayVo对象) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endOffDay = data["endOffDay"] ? new Date(data["endOffDay"].toString()) : <any>undefined;
            this.id = data["id"];
            this.remark = data["remark"];
            this.startOffDay = data["startOffDay"] ? new Date(data["startOffDay"].toString()) : <any>undefined;
            this.year = data["year"];
        }
    }

    static fromJS(data: any): ShiftOffDayVo对象 {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftOffDayVo对象();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endOffDay"] = this.endOffDay ? formatDate(this.endOffDay) : <any>undefined;
        data["id"] = this.id;
        data["remark"] = this.remark;
        data["startOffDay"] = this.startOffDay ? formatDate(this.startOffDay) : <any>undefined;
        data["year"] = this.year;
        return data; 
    }
}

/** 班次休息日 */
export interface IShiftOffDayVo对象 {
    /** 休息日-结束 */
    endOffDay: Date | undefined;
    /** 主键 */
    id: string | undefined;
    /** 备注/说明 */
    remark: string | undefined;
    /** 休息日-开始 */
    startOffDay: Date | undefined;
    /** 年份 */
    year: number | undefined;
}

/** 班次休息日 */
export class ShiftOffDayVo对象_1 implements IShiftOffDayVo对象_1 {
    /** 休息日-结束 */
    endOffDay!: Date | undefined;
    /** 备注/说明 */
    remark!: string | undefined;
    /** 休息日-开始 */
    startOffDay!: Date | undefined;
    /** 年份 */
    year!: number | undefined;

    constructor(data?: IShiftOffDayVo对象_1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endOffDay = data["endOffDay"] ? new Date(data["endOffDay"].toString()) : <any>undefined;
            this.remark = data["remark"];
            this.startOffDay = data["startOffDay"] ? new Date(data["startOffDay"].toString()) : <any>undefined;
            this.year = data["year"];
        }
    }

    static fromJS(data: any): ShiftOffDayVo对象_1 {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftOffDayVo对象_1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endOffDay"] = this.endOffDay ? formatDate(this.endOffDay) : <any>undefined;
        data["remark"] = this.remark;
        data["startOffDay"] = this.startOffDay ? formatDate(this.startOffDay) : <any>undefined;
        data["year"] = this.year;
        return data; 
    }
}

/** 班次休息日 */
export interface IShiftOffDayVo对象_1 {
    /** 休息日-结束 */
    endOffDay: Date | undefined;
    /** 备注/说明 */
    remark: string | undefined;
    /** 休息日-开始 */
    startOffDay: Date | undefined;
    /** 年份 */
    year: number | undefined;
}

/** 班次休息日 */
export class ShiftOffDayVo对象_2 implements IShiftOffDayVo对象_2 {
    /** 休息日-结束 */
    endOffDay!: Date | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 备注/说明 */
    remark!: string | undefined;
    /** 休息日-开始 */
    startOffDay!: Date | undefined;
    /** 年份 */
    year!: number | undefined;

    constructor(data?: IShiftOffDayVo对象_2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endOffDay = data["endOffDay"] ? new Date(data["endOffDay"].toString()) : <any>undefined;
            this.id = data["id"];
            this.remark = data["remark"];
            this.startOffDay = data["startOffDay"] ? new Date(data["startOffDay"].toString()) : <any>undefined;
            this.year = data["year"];
        }
    }

    static fromJS(data: any): ShiftOffDayVo对象_2 {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftOffDayVo对象_2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endOffDay"] = this.endOffDay ? formatDate(this.endOffDay) : <any>undefined;
        data["id"] = this.id;
        data["remark"] = this.remark;
        data["startOffDay"] = this.startOffDay ? formatDate(this.startOffDay) : <any>undefined;
        data["year"] = this.year;
        return data; 
    }
}

/** 班次休息日 */
export interface IShiftOffDayVo对象_2 {
    /** 休息日-结束 */
    endOffDay: Date | undefined;
    /** 主键 */
    id: string | undefined;
    /** 备注/说明 */
    remark: string | undefined;
    /** 休息日-开始 */
    startOffDay: Date | undefined;
    /** 年份 */
    year: number | undefined;
}

export class ShiftRestTimeDTO implements IShiftRestTimeDTO {
    /** 主键id */
    id!: string | undefined;
    /** 休息时段结束时间 */
    restEndTime!: number | undefined;
    /** 休息时段下标 */
    restIndex!: number | undefined;
    /** 休息时段开始时间 */
    restStartTime!: number | undefined;

    constructor(data?: IShiftRestTimeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.restEndTime = data["restEndTime"];
            this.restIndex = data["restIndex"];
            this.restStartTime = data["restStartTime"];
        }
    }

    static fromJS(data: any): ShiftRestTimeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftRestTimeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["restEndTime"] = this.restEndTime;
        data["restIndex"] = this.restIndex;
        data["restStartTime"] = this.restStartTime;
        return data; 
    }
}

export interface IShiftRestTimeDTO {
    /** 主键id */
    id: string | undefined;
    /** 休息时段结束时间 */
    restEndTime: number | undefined;
    /** 休息时段下标 */
    restIndex: number | undefined;
    /** 休息时段开始时间 */
    restStartTime: number | undefined;
}

export class ShiftRestTimeVO implements IShiftRestTimeVO {
    /** 主键id */
    id!: string | undefined;
    /** 休息时段结束时间 */
    restEndTime!: number | undefined;
    /** 休息时段序号 */
    restIndex!: number | undefined;
    /** 休息时段开始时间 */
    restStartTime!: number | undefined;

    constructor(data?: IShiftRestTimeVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.restEndTime = data["restEndTime"];
            this.restIndex = data["restIndex"];
            this.restStartTime = data["restStartTime"];
        }
    }

    static fromJS(data: any): ShiftRestTimeVO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftRestTimeVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["restEndTime"] = this.restEndTime;
        data["restIndex"] = this.restIndex;
        data["restStartTime"] = this.restStartTime;
        return data; 
    }
}

export interface IShiftRestTimeVO {
    /** 主键id */
    id: string | undefined;
    /** 休息时段结束时间 */
    restEndTime: number | undefined;
    /** 休息时段序号 */
    restIndex: number | undefined;
    /** 休息时段开始时间 */
    restStartTime: number | undefined;
}

export class ShiftSimpleVO implements IShiftSimpleVO {
    /** 班次编号 */
    code!: string | undefined;
    /** 班次颜色 */
    colour!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 班次名称 */
    name!: string | undefined;

    constructor(data?: IShiftSimpleVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.colour = data["colour"];
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ShiftSimpleVO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftSimpleVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["colour"] = this.colour;
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IShiftSimpleVO {
    /** 班次编号 */
    code: string | undefined;
    /** 班次颜色 */
    colour: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 班次名称 */
    name: string | undefined;
}

export class ShiftUpdateBasicDTO implements IShiftUpdateBasicDTO {
    /** 班次颜色 */
    colour!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 班次名称 */
    name!: string | undefined;
    /** 启用禁用按钮1-启动0-禁用 */
    status!: number | undefined;

    constructor(data?: IShiftUpdateBasicDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.colour = data["colour"];
            this.id = data["id"];
            this.name = data["name"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): ShiftUpdateBasicDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftUpdateBasicDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colour"] = this.colour;
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IShiftUpdateBasicDTO {
    /** 班次颜色 */
    colour: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 班次名称 */
    name: string | undefined;
    /** 启用禁用按钮1-启动0-禁用 */
    status: number | undefined;
}

export class ShiftUpdateDTO implements IShiftUpdateDTO {
    /** 班次日结束时间 */
    endTime!: number | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 班次数量 */
    number!: number | undefined;
    /** 班次时间 */
    shiftDetailDTOList!: ShiftDetailDTO[] | undefined;
    /** 班次日开始时间 */
    startTime!: number | undefined;

    constructor(data?: IShiftUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endTime = data["endTime"];
            this.id = data["id"];
            this.number = data["number"];
            if (data["shiftDetailDTOList"] && data["shiftDetailDTOList"].constructor === Array) {
                this.shiftDetailDTOList = [] as any;
                for (let item of data["shiftDetailDTOList"])
                    this.shiftDetailDTOList!.push(ShiftDetailDTO.fromJS(item));
            }
            this.startTime = data["startTime"];
        }
    }

    static fromJS(data: any): ShiftUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endTime"] = this.endTime;
        data["id"] = this.id;
        data["number"] = this.number;
        if (this.shiftDetailDTOList && this.shiftDetailDTOList.constructor === Array) {
            data["shiftDetailDTOList"] = [];
            for (let item of this.shiftDetailDTOList)
                data["shiftDetailDTOList"].push(item.toJSON());
        }
        data["startTime"] = this.startTime;
        return data; 
    }
}

export interface IShiftUpdateDTO {
    /** 班次日结束时间 */
    endTime: number | undefined;
    /** 主键 */
    id: string | undefined;
    /** 班次数量 */
    number: number | undefined;
    /** 班次时间 */
    shiftDetailDTOList: ShiftDetailDTO[] | undefined;
    /** 班次日开始时间 */
    startTime: number | undefined;
}

export class ShiftVO implements IShiftVO {
    /** 班次编号 */
    code!: string | undefined;
    /** 班次颜色 */
    colour!: string | undefined;
    /** 班次日结束时间 */
    endTime!: number | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 是否被使用(0：否，1：是) */
    isUsed!: number | undefined;
    /** 班次名称 */
    name!: string | undefined;
    /** 班次数量 */
    number!: number | undefined;
    /** 班次时间 */
    shiftDetailVOList!: ShiftDetailVO[] | undefined;
    /** 班次日开始时间 */
    startTime!: number | undefined;

    constructor(data?: IShiftVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.colour = data["colour"];
            this.endTime = data["endTime"];
            this.id = data["id"];
            this.isUsed = data["isUsed"];
            this.name = data["name"];
            this.number = data["number"];
            if (data["shiftDetailVOList"] && data["shiftDetailVOList"].constructor === Array) {
                this.shiftDetailVOList = [] as any;
                for (let item of data["shiftDetailVOList"])
                    this.shiftDetailVOList!.push(ShiftDetailVO.fromJS(item));
            }
            this.startTime = data["startTime"];
        }
    }

    static fromJS(data: any): ShiftVO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["colour"] = this.colour;
        data["endTime"] = this.endTime;
        data["id"] = this.id;
        data["isUsed"] = this.isUsed;
        data["name"] = this.name;
        data["number"] = this.number;
        if (this.shiftDetailVOList && this.shiftDetailVOList.constructor === Array) {
            data["shiftDetailVOList"] = [];
            for (let item of this.shiftDetailVOList)
                data["shiftDetailVOList"].push(item.toJSON());
        }
        data["startTime"] = this.startTime;
        return data; 
    }
}

export interface IShiftVO {
    /** 班次编号 */
    code: string | undefined;
    /** 班次颜色 */
    colour: string | undefined;
    /** 班次日结束时间 */
    endTime: number | undefined;
    /** 主键 */
    id: string | undefined;
    /** 是否被使用(0：否，1：是) */
    isUsed: number | undefined;
    /** 班次名称 */
    name: string | undefined;
    /** 班次数量 */
    number: number | undefined;
    /** 班次时间 */
    shiftDetailVOList: ShiftDetailVO[] | undefined;
    /** 班次日开始时间 */
    startTime: number | undefined;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}